import { useState } from 'react';
import { cn } from '@/utils/cn';
import { MarpleLogo } from './MarpleLogo';
import { useSiteBrand } from '@/context/SiteConfigContext';

interface DynamicLogoProps {
  variant?: 'default' | 'white' | 'black' | 'colored';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  animate?: boolean;
}

export function DynamicLogo({
  variant = 'default',
  size = 'md',
  showText = false,
  className,
  animate = false,
}: DynamicLogoProps) {
  const { logoUrl } = useSiteBrand();
  // A configured logo that 404s previously rendered a broken-image icon on
  // every page and in every email-facing surface. Fall back to the built-in
  // mark instead, which is always available.
  const [imageFailed, setImageFailed] = useState(false);

  if (logoUrl && !imageFailed) {
    return (
      <img
        src={logoUrl}
        alt="Marple & Co."
        onError={() => setImageFailed(true)}
        className={cn('h-auto object-contain', className)}
        style={{
          height: size === 'sm' ? 32 : size === 'md' ? 48 : size === 'lg' ? 64 : 96,
        }}
      />
    );
  }

  return (
    <MarpleLogo
      variant={variant}
      size={size}
      showText={showText}
      className={className}
      animate={animate}
    />
  );
}
